import { Injectable } from '@angular/core';
import { Platform } from '@ionic/angular';
import { GlobalAuthResolver } from 'src/app/appServices/global-auth/global-auth.resolver';
import { InstantDepositeSchedularService } from 'src/app/appServices/instant-deposite-schedular';
import { ThemeService } from 'src/app/appServices/theme.service';
import { BreakpointService } from '../utilities/breakpoint.service';
import { CheckForUpdateService } from '../utilities/check-for-update.service';
import { TokenService } from '../auth/token.service';

@Injectable({
  providedIn: 'root',
})
export class AppInitializerService {
  constructor(
    private platform: Platform,
    private _breakpointService: BreakpointService,
    private _sw: CheckForUpdateService,
    private _globalAuthResolver: GlobalAuthResolver,
    private themeService: ThemeService,
    private instantDepositeSchedular: InstantDepositeSchedularService,
    private tokenService: TokenService,
  ) {}

  /**
   * Initializes the app on startup.
   */
  async initializeApp() {
    await this.platform.ready();
    
    // Continue with normal app initialization
    this.themeService.detectSystemTheme();
    this._breakpointService.onResize(this.platform.width());
    await this.checkLogin();
    
    this._sw.checkIfUpdateAvailable();
  }

  /**
   * check login
   */
  async checkLogin() {
    await this.tokenService.ensureTokenLoaded();
    const state = this.tokenService.getTokenState();
    if (state === 'valid') {
      this._globalAuthResolver.beginSession();
      this.instantDepositeSchedular.initInstantDepositeSchedular();
      return;
    }
    if (state === 'expired' || state === 'malformed') {
      try {
        await this.tokenService.invalidateIfCurrent(this.tokenService.token);
      } catch (error) {
        // The in-memory token is cleared synchronously. A native Preferences
        // failure must not abort the rest of application startup or keep the
        // login screen from becoming usable.
        console.error('Expired authentication token cleanup failed', error);
      }
    }
  }
}
